var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmDialogConfirmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2051_37812)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2051_37812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9995 22.4004C41.2164 22.4004 42.1995 23.3835 42.1995 24.6004V25.8173C51.2608 26.7591 58.5414 33.4691 59.6551 42.056C59.7926 43.1285 58.4658 43.7335 57.7439 42.9291C56.7814 41.8566 54.9045 41.1004 53.1995 41.1004C50.5389 41.1004 48.3183 42.991 47.8095 45.5073C47.6926 46.1054 47.2114 46.6004 46.5995 46.6004C45.9876 46.6004 45.5133 46.1054 45.3895 45.5073C44.8808 42.991 42.6601 41.1004 39.9995 41.1004C37.3389 41.1004 35.1183 42.991 34.6095 45.5073C34.4926 46.1054 34.0114 46.6004 33.3995 46.6004C32.7876 46.6004 32.3133 46.1054 32.1895 45.5073C31.6808 42.991 29.4601 41.1004 26.7995 41.1004C25.0945 41.1004 23.2176 41.8566 22.2551 42.936C21.5333 43.7404 20.2064 43.1354 20.3439 42.0629C21.4576 33.4691 28.7383 26.7591 37.7995 25.8173V24.6004C37.7995 23.3835 38.7826 22.4004 39.9995 22.4004ZM39.9995 43.3004C40.8451 43.3004 41.6151 43.6166 42.1995 44.1391V52.0041C42.1995 55.0979 39.6901 57.6004 36.6033 57.6004C34.4858 57.6004 32.547 56.4041 31.5983 54.5066L31.4401 54.1835C30.897 53.0973 31.337 51.7773 32.4233 51.2341C33.5095 50.691 34.8295 51.131 35.3726 52.2173L35.5308 52.5404C35.737 52.946 36.1495 53.2004 36.6033 53.2004C37.2633 53.2004 37.7995 52.6641 37.7995 52.0041V44.1391C38.3839 43.6166 39.1539 43.3004 39.9995 43.3004Z",
    fill: "#212529",
    fillOpacity: 0.7
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2051_37812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2051_37812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 35.2,
    fill: "white",
    transform: "translate(18 22.4004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmDialogConfirmIcon);
export default __webpack_public_path__ + "static/media/confirm-dialog-confirm-icon.251eee6a12ad43b4c00fffaeaf318445.svg";
export { ForwardRef as ReactComponent };